export default __webpack_public_path__ + "static/media/WoodTeaCoasterProductInfo.1f2ed60a.jpg";